//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import throttle from 'lodash.throttle'
import sortBy from 'lodash.sortby'
import blok from '~/mixins/blok'
import { legalHubArticleListExcludedFields, legalHubArticleExcludedTypes } from '~/utils/constants'

// These should match your directory structure
const topicPathByLocale = {
  'fi-fi': 'aihe',
  'en-gb': 'topic',
  'sv-se': 'tema',
}

export default {
  mixins: [blok],

  data () {
    const pathParts = this.$route.path.split('/')

    // If we're using this component as a selected category's page, the path will be exactly 5 items long (empty, country, base name, topic title, topic name). Kind of a hacky way to check this, but it's simplest and should be robust.
    const isCategoryPage = pathParts.length === 5

    let selectedCategoryKey = null
    if (isCategoryPage) {
      // "_" stands for no category filter, aka "all".
      selectedCategoryKey = pathParts[4] !== '_' ? pathParts[4] : null
    }

    return {
      isCategoryPage,
      // Search term is set later on mount
      searchTerm: '',
      searchFieldVal: '',
      selectedCategoryKey,
      articles: null,
      // 0 is the "preview" page with fewer items, but after that we fetch in larger batches. If the user has selected a category, we show page 1 immediately, instead of the preview page.
      articlesPage: isCategoryPage ? 1 : 0,
      articlesAllFetched: false,
      fetchingMoreArticles: false,
      newArticles: null,
      highlightArticles: [],
      articleCategories: null,
    }
  },

  fetchKey (getCounter) {
    return `legal-hub-layout:${this.$route.path}:${getCounter('legal-hub-layout')}`
  },

  async fetch () {
    const country = this.getArticleCategoriesCountry()
    const lang = this.$country.current.language

    const categoriesRes = await this.$sb.get('cdn/datasource_entries', {
      datasource: `legal-hub-article-categories-${country}`,
      dimension: lang,
      per_page: 100,
    })
    this.articleCategories = categoriesRes.data.datasource_entries

    await Promise.all([
      this.fetchArticles(false),
      this.fetchNewArticles(),
      this.fetchHighlightArticles(),
    ])
  },

  computed: {
    heroImg () {
      return this.$sb.parseImage(this.blok.hero_img)
    },

    legalHubBasePrefix () {
      return this.$url.articlesIndex().substring(1)
    },

    topicPathPart () {
      const code = this.$country.current.code
      return topicPathByLocale[code]
    },

    selectedCategory () {
      if (!(this.articleCategories && this.selectedCategoryKey)) {
        return null
      }
      return this.articleCategories.find(x => x.value === this.selectedCategoryKey)
    },

    selectedCategoryTitle () {
      if (!this.selectedCategory) {
        return this.$t('legalHub.all')
      }

      return this.selectedCategory.name
    },

    searchQueryStr () {
      return this.searchTerm ? `?search=${encodeURIComponent(this.searchTerm)}` : ''
    },

    breadcrumbItems () {
      return [
        { title: this.$t('legalHub.legalHub'), url: this.$url.articlesIndex() },
        { title: this.isCategoryPage ? this.selectedCategoryTitle : this.$t('legalHub.searchTitle') },
      ]
    },
  },

  watch: {
    '$route.query' (newQuery, oldQuery) {
      // The query controls `this.searchTerm` and article fetching
      if (newQuery.search !== oldQuery.search) {
        this.searchTerm = newQuery.search
        // Searching resets the current page
        this.articlesPage = 1

        this.fetchArticles(false)

        // If the query's search doesn't match the search input, the user likely navigated their browser history, so update the input to match that
        if (newQuery.search !== this.searchFieldVal) {
          this.searchFieldVal = newQuery.search
        }
      }
    }
  },

  async mounted () {
    this._searchArticlesDebounced = throttle(this.searchArticles, 150)

    // Query won't be available at static rendering time, so it needs to be read client-side here
    const searchTerm = this.$route.query.search || ''

    if (searchTerm) {
      this.searchTerm = searchTerm
      this.searchFieldVal = searchTerm
      // See other comments, if we've been given a search term we use page 1 instead of the preview page 0 (to fetch more articles)
      this.articlesPage = 1

      // Do a fresh article fetch with the given search terms
      await this.fetchArticles(false)
    }
  },

  methods: {
    // NOTE: We default to GB categories if no country is selected! Currently our articles don't have separate categories for non-localized / global access, since the site also defaults to en-gb for non-supported countries. We may introduce a new country such as "global" later if needed.
    getArticleCategoriesCountry () {
      return (this.$country.current.countryCode || 'gb').toLowerCase()
    },

    async fetchArticles (append) {
      const startTime = Date.now()
      this.latestArticleFetchTime = startTime

      const country = this.getArticleCategoriesCountry()

      // See above, load fewer items if we're on the "preview" page
      const perPage = this.searchTerm || this.articlesPage ? 27 : 9
      const page = this.articlesPage || 1

      let meiliFilter = null
      if (this.selectedCategory) {
        const categoriesField = `article-categories-${country}`
        meiliFilter = `${categoriesField} = '${this.selectedCategory.value}'`
      }

      let totalPages = 1

      let meiliRes = null
      if (this.searchTerm) {
        meiliRes = await this.$meili.search('legal_hub', {
          q: this.searchTerm,
          hitsPerPage: perPage,
          page,
          filter: meiliFilter,
          attributesToRetrieve: ['path'],
        })
        totalPages = meiliRes.totalPages
      }

      // Yield if a newer fetch has been triggered
      if (this.latestArticleFetchTime !== startTime) {
        return
      }

      let articles = null
      // Had a search term but no results -> no need to do anything else
      if (meiliRes && !meiliRes.hits.length) {
        articles = []
      // Had a search term -> get results that match what Meili returned
      } else if (meiliRes) {
        const articleSlugsStr = meiliRes.hits.map(x => x.path.substring(1)).join(',')

        // Note: We could skip fetching articles from SB if we included a bit more data in them on Meili's side so that they'd work with LegalHubResourceCard
        const sbParams = {
          by_slugs: articleSlugsStr,
          per_page: 100,
          excluding_fields: legalHubArticleListExcludedFields,
        }
        const sbRes = await this.$sb.list(this.legalHubBasePrefix, sbParams)
        const articleStories = sbRes.data.stories

        // Storyblok of course doesn't sort the articles by the `by_slugs` attribute so we need to do that here
        const meiliRankings = {}
        for (let i = 0; i < meiliRes.hits.length; ++i) {
          const item = meiliRes.hits[i]
          meiliRankings[item.path.substring(1)] = i
        }

        articles = sortBy(articleStories, x => meiliRankings[x.full_slug])
      // No search term -> fetch from SB, skipping meili. This makes our statically rendered pages work better since the build step doesn't require meili or existing earlier indexes.
      } else {
        const sbParams = {
          is_startpage: 0,
          filter_query: { component: { not_in: legalHubArticleExcludedTypes } },
          excluding_fields: legalHubArticleListExcludedFields,
          page,
          per_page: perPage,
          sort_by: 'content.meta.title:asc',
        }
        if (this.selectedCategory) {
          const categoriesField = `article_categories_${country}`
          sbParams.filter_query[categoriesField] = { any_in_array: this.selectedCategory.value }
        }
        const sbRes = await this.$sb.list(this.legalHubBasePrefix, sbParams)

        articles = sbRes.data.stories

        // Also update this
        totalPages = Math.ceil(sbRes.headers.total / sbRes.headers['per-page'])
      }

      if (this.latestArticleFetchTime !== startTime) {
        return
      }

      // Make sure that `this.articles` is initialized if we try appending into it, there might be some edge cases where request delays could mess this up.
      if (append && this.articles) {
        this.articles = [...this.articles, ...articles]
      } else {
        this.articles = articles
      }

      this.articlesAllFetched = page >= totalPages

      this.fetchingMoreArticles = false
    },

    async fetchNewArticles (append) {
      const params = {
        is_startpage: 0,
        filter_query: { component: { not_in: legalHubArticleExcludedTypes } },
        excluding_fields: legalHubArticleListExcludedFields,
        page: 1,
        per_page: 3,
        sort_by: 'published_at:desc',
      }
      const pageRes = await this.$sb.list(this.legalHubBasePrefix, params)

      this.newArticles = pageRes.data.stories
    },

    async fetchHighlightArticles (append) {
      if (this.blok.essential_section_items.length === 0) {
        return
      }

      const uuidFilter = this.blok.essential_section_items.join(',')

      const params = {
        by_uuids_ordered: uuidFilter,
        excluding_fields: legalHubArticleListExcludedFields,
        page: 1,
        per_page: 4,
      }
      const pageRes = await this.$sb.list('', params)

      this.highlightArticles = pageRes.data.stories
    },

    // This just really updates the query
    searchArticles (searchTerm) {
      // Bail if user searches without changing the term
      if (this.searchTerm === searchTerm) {
        return
      }

      if (searchTerm) {
        // If we're inputting the first search character, ie entering search, don't replace the earlier item in the history stack. Otherwise replace the previous search string entry to not pollute history.
        const method = this.searchTerm === '' ? 'push' : 'replace'
        this.$router[method]({ query: { search: searchTerm } })
      } else {
        // The empty array means an empty query
        this.$router.push({ query: [] })
      }
    },

    searchArticlesAsTyped (searchTerm) {
      this._searchArticlesDebounced(searchTerm)
    },

    resetSearch () {
      this.searchFieldVal = ''

      this.searchArticles('')
    },

    async loadMoreArticles () {
      // Keeps double clicks from causing problems with state (incrementing page number before the previous batch is fetched)
      if (this.fetchingMoreArticles) {
        return
      }

      this.articlesPage += 1
      this.fetchingMoreArticles = true

      // If we're currently fetching page 1 for more articles, that means we were on the initial "preview" page (see above) and want to replace the list of articles rather than append to it.
      await this.fetchArticles(this.articlesPage !== 1)
    },
  }
}

